import TomSelect from 'tom-select/dist/js/tom-select.base.js';
import TomSelect_remove_button from 'tom-select/dist/js/plugins/remove_button.js';

TomSelect.define('remove_button', TomSelect_remove_button);

export function initOnQuerySelector(elementId, delimiter, maxItems) {
  new TomSelect(elementId,{
    plugins: ['remove_button'],
    create: true,
    // persist: false,
    onItemAdd:function(){
      this.setTextboxValue('');
    },
    maxItems: maxItems,
    delimiter: delimiter,
    createOnBlur: true,
    onItemRemove: function(value) {
      this.removeOption(value);
      this.refreshOptions();
    },
    render: {
      dropdown:function(){
        return '<div class="hidden"></div>';
      }
    }
  });
}
